export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('STATE_SHOULD_BE_BROUILLON') === 0) {
      const code = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'listeContrat.popUpSuppression.messagesError',
        parametres: {
          code: code,
        },
      });
    }
  });
}
